import React, { useEffect, useState } from 'react';
import {
	Grid,
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Box,
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { CountryList } from '@components/CountryList';
import { TagList } from '@components/TagList';
import Input from '@components/Input';

const INIT_FORM_DATA = {
	title: '',
	label: [],
	country: '',
	isActive: true
};

const INIT_ERRORS = {
	title: '',
	label: '',
	country: ''
};

const AddRecommendation = ({ isVisible, onClose, onSubmit, existingFormData, labels, country }) => {
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
	const isUpdate = Object.keys(existingFormData || {}).length !== 0;

	const [errors, setErrors] = useState(INIT_ERRORS);
	const [formData, setFormData] = useState({ ...INIT_FORM_DATA, country: country });
	const [hasError, setHasError] = useState(false);

	useEffect(() => {
		if (!!existingFormData) {			
			setFormData({ 
				...existingFormData,
				label: !!labels && labels.length > 0 && !!existingFormData.label && existingFormData.label.length > 0 ? existingFormData.label.map(l => labels.find(e => e.id === l.id)).filter(e => !!e) : []
			});
		}
	}, [existingFormData, labels]);

	useEffect(() => {
		if (!country) return;
		setFormData((prevState) => ({
			...prevState,
			country,
		}));
	}, [country]);

	useEffect(() => {
		const keys = Object.keys(errors);
		let hasValue = true;
		keys.forEach((errKey) => {
			if (formData[errKey] === '' || formData[errKey] === null) {
				hasValue = false;
			}
		});

		setHasError(!hasValue);
	}, [formData, errors]);


	const handleCloseModal = (e) => {
		e && e.stopPropagation();
		setErrors(INIT_ERRORS);
		setFormData({ ...INIT_FORM_DATA, country });
		onClose(false);
	};

	const validateField = (name, value) => {
		if (!(name in errors)) {
			return;
		}

		setErrors((prevState) => ({
			...prevState,
			[name]: value ? '' : 'This field is required.',
		}));
	};

	const validateHasError = (name, value) => {
		if (!(name in errors)) {
			return false;
		}

		return !(value !== null && value !== '' && value !== undefined);
	};

	const handleInputChange = (event, type) => {
		const { id, value } = event.target;

		setFormData((prevState) => ({
			...prevState,
			[id]: value,
		}));

		if (type === 'number') {
			setErrors((prevState) => ({
				...prevState,
				[id]: value <= 0 ? 'Only accept positive numbers' : '',
			}));
			return;
		}

		validateField(id, value);
	};

	const inputPropsHandlers = {
		onChangeBlur: handleInputChange,
	};

	const handlSelectChange = (country) => {
		if (!country) return;
		setFormData((prevState) => ({
			...prevState,
			country,
		}));
	};

	const onSubmitHandler = () => {
		const items = Object.keys({ ...formData });

		let isAllFieldsValidated = true;

		items.forEach((item) => {
			validateField(item, formData[item]);
			if (validateHasError(item, formData[item])) {
				isAllFieldsValidated = false;
			}
		});

		if (isAllFieldsValidated) {
			const payload = {
				...formData,
				label: formData.label.map(l => ({ id: l.id }))
			};
			onSubmit({ ...payload });
			handleCloseModal();
		}
	};

	const handleSelectedOptionsChange = (selectedOptions) => {
		setFormData((prevState) => ({
			...prevState,
			label: [...selectedOptions],
		}));
	};

	return (
		<Dialog
			open={isVisible}
			onClose={handleCloseModal}
			fullScreen={fullScreen}
			scroll="paper"
			maxWidth={'sm'}
		>
			<DialogTitle id="scroll-dialog-title" onClose={onClose}>
				{isUpdate ? "Update" : "New"} Recommendation
			</DialogTitle>
			<DialogContent dividers>
				<Box sx={{ flexGrow: 1 }}>
					<Grid container spacing={3} columns={12} direction="column">
						<Grid item md={7} xs={12}>
							<Box sx={{ flexGrow: 1 }}>
								<Grid container spacing={3}>
									<Grid container item md={12} xs={12}>
										<Input
											{...inputPropsHandlers}
											id="title"
											label="Title"
											value={formData.title}
											error={errors.title}
										/>
									</Grid>
									<Grid container item>
										<Grid item md={12} xs={12}>
											<TagList
												isMultiple={true}
												options={labels}
												value={formData && formData.label}
												filterSelectedOptions={true}
												onSelectedOptionsChange={handleSelectedOptionsChange}
											/>
										</Grid>
									</Grid>
									<Grid container item md={12} xs={12}>
										<CountryList
											disabled
											onChange={handlSelectChange}
											placeholder="Select Country"
											id="country"
											label="Country name"
											variant="filled"
											value={formData.country != null ? formData.country : ''}
											error={!!errors.title}
										/>
									</Grid>
								</Grid>
							</Box>
						</Grid>
					</Grid>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleCloseModal}>Cancel</Button>
				<Button
					variant="contained"
					onClick={onSubmitHandler}
					disabled={hasError}
				>
					{isUpdate ? 'Update' : 'Create'}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default AddRecommendation;
